<template>
    <div
            class="card"
    >

        <div>
            <Dictionary class="dictionary"
                        module="facebookBrowserDetected"
                        string="subtitle"
                        :replace="{subdomain: subdomain}"
            />
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Dictionary from '../../app/global/components/Dictionary.vue';

export default Vue.extend({
  name: 'FacebookBrowserMessage',
  components: {
    Dictionary,
  },
  props: {
    subdomain: {
      required: true,
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  updated() {
  },
  destroyed() {
  },
});
</script>

<style scoped>
    .dictionary {
        font-size: 14px;
        padding: 12px;
    }

    .col {
        padding: 0 12px 0 12px;
    }

    .card {
        min-width: 100%;
        padding: 8px;
        margin: auto;
        border-width: thin;
        display: block;
        background-color: white;
        outline: none;
        text-decoration: none;
        transition-property: box-shadow, opacity;
        overflow-wrap: break-word;
        position: relative;
        white-space: normal;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    }

    .container {
        padding: 0;
    }
</style>
